import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import { selectLeadListAction } from "app/pages/workspace/sales/sub-modules/opportunities-lists/store/action-creators";

import type { UseStatisticsMapByListId } from "../../usage-statistics/types";
import type { SignalsContainer, SignalWithId, SignalSubFilter } from "../types";

import * as ac from "./action-creators";

type SignalsActions = ActionType<typeof ac> | ActionType<typeof selectLeadListAction>;

export type SignalsState = {
    signalsContainer: SignalsContainer;
    signalsFetching: boolean;
    signalsFetchError?: string;
    restCountriesSignalsByName: SignalsContainer;
    signalsUse: UseStatisticsMapByListId;
    selectedFilterId: SignalWithId["id"] | null;
    selectedSubFilterId: SignalSubFilter["code"] | null;
    activeTabIndex: number;
};

const INITIAL_SIGNALS_STATE: SignalsState = {
    signalsContainer: {
        total: 0,
        filters: {},
    },
    signalsFetching: false,
    restCountriesSignalsByName: {
        total: 0,
        filters: {},
    },
    signalsUse: {},
    selectedFilterId: null,
    selectedSubFilterId: null,
    activeTabIndex: 0,
};

const signalsReducer = createReducer<SignalsState, SignalsActions>(INITIAL_SIGNALS_STATE)
    .handleAction(ac.fetchSignalsAsyncAction.request, (state) => ({
        ...state,
        signalsFetching: true,
        signalsFetchError: INITIAL_SIGNALS_STATE.signalsFetchError,
    }))
    .handleAction(ac.fetchSignalsAsyncAction.success, (state, { payload }) => ({
        ...state,
        signalsFetching: false,
        signalsContainer: payload,
    }))
    .handleAction(ac.fetchSignalsAsyncAction.failure, (state, { payload }) => ({
        ...state,
        signalsFetching: false,
        signalsFetchError: payload,
    }))
    .handleAction(ac.fetchRestCountriesSignalsSuccessAction, (state, { payload }) => ({
        ...state,
        restCountriesSignalsByName: payload,
    }))
    .handleAction(ac.getSignalsUseAsyncAction.success, (state, { payload }) => ({
        ...state,
        signalsUse: payload,
    }))
    .handleAction(selectLeadListAction, (state) => ({
        ...state,
        selectedFilterId: null,
        selectedSubFilterId: null,
    }));

export default signalsReducer;
